import { useTranslation } from 'react-i18next';
import SearchableSelect from '../../searchableSelect/searchableSelect';
import { useTransactionTypeSelect } from './useTransactionTypeSelect';

interface TransactionTypeSelectProps {
  disabled: boolean;
  onOpenPicker: () => void;
  onClear?: () => void;
}

/**
 * Its own component so the transaction type list is only fetched where the field is rendered. It
 * renders the trigger button directly, which lookup siblings like `LookupClearButton` rely on.
 */
const TransactionTypeSelect = ({
  disabled,
  onOpenPicker,
  onClear,
}: Readonly<TransactionTypeSelectProps>) => {
  const { t } = useTranslation();
  const select = useTransactionTypeSelect();

  return (
    <SearchableSelect
      {...select}
      disabled={disabled}
      ariaLabel={t('transaction:transactionType.transactionType')}
      placeholder={t('transaction:selectTransactionType')}
      searchPlaceholder={t('transaction:searchTransactionTypes')}
      onSearchIconClick={onOpenPicker}
      onClear={onClear}
      data-field="transactionType"
      data-testid="select-transaction-type-button"
    />
  );
};

export default TransactionTypeSelect;
